<template>
  <div>

 <v-card class="mt-4 pt-2 pb-2" flat>
      <v-card-actions>
        <v-select
          outlined
          v-model="SelVenue"
          :items="VenueName"
          item-text="venue_name"
          item-value="venue_id"
          label="Select Venue"
          dense
          :rules="[(v) => !!v || 'Venue is required']"
          required
        
          hide-details
          full-width
        ></v-select>
          <v-btn
              outlined
              medium
              color="primary"
              v-bind="attrs"
              class="pl-2 ma-1"
              @click="searchdata()"
            >
              <v-icon>mdi-magnify</v-icon>
              SEARCH
            </v-btn>
      <v-btn
              outlined
              medium
              color="primary"
              v-bind="attrs"
              class="pl-2 ma-1"
              @click="New()"
            >
              <v-icon>mdi-plus</v-icon>
              NEW
            </v-btn>
       
      </v-card-actions>
    </v-card>

    <div class="text-right">
      <template>
       
         

        <v-data-table
          :headers="headers"
          :items="desserts"
          sort-by="calories"
          class="elevation-1"
          :search="search"
          :loading="loadingstatus"
          loading-text="Loading... Please wait"
        >
          <template v-slot:top>
          
                        <v-text-field
              v-model="search"
              label="Search"
              single-line
              hide-details
              class="ml-4 mr-4 mb-5"
            ></v-text-field>
                  
          </template>

          <template v-slot:item.actions="{ item }">
            <v-icon small class="mr-2" @click="editItem(item)"
              >mdi-pencil</v-icon
            >
            <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
          </template>
          <template v-slot:no-data>
            <!-- <v-btn color="primary" @click="initialize">Reset</v-btn> -->
            No Record(s)
          </template>
        </v-data-table>
      </template>

      <v-navigation-drawer v-model="sheet" right persistent temporary  fixed style="width: 100%; max-width:800px; margin: auto">
        <v-sheet class="text-center" min-height="200px" color="#cccccc">
          <div class="text-left">
            <v-card
              flat
              max-width="800px"
              style="width: 100%; margin: auto"
              class="pa-3"
            >
              <v-toolbar color="transparent" flat>
                {{ EntryMode }} {{ VenueID }}
                <v-spacer></v-spacer>

                <v-btn icon light>
                  <v-icon color="grey darken-2" @click="sheet = !sheet"
                    >mdi-close</v-icon
                  >
                </v-btn>
              </v-toolbar>
              <v-divider></v-divider>
              <v-form ref="form" v-model="valid">
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="6" md="12">
                      <v-text-field
                        v-model="postBody.stand_name"
                        label="Stand Name*"
                        outlined
                        required
                        dense
                        hide-details
                      ></v-text-field>
                    </v-col>

                     <v-col cols="12" sm="6" md="12">
                      <v-text-field
                        v-model="postBody.print_text"
                        label="Print Text*"
                        outlined
                        required
                        dense
                        hide-details
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="6" md="12">
                      <v-text-field
                        label="Gate No*"
                        outlined
                        required
                        dense
                        hide-details
                        v-model="postBody.gate_no"
                      ></v-text-field>
                    </v-col>

 <v-col cols="12" sm="6" md="12">
                      <v-text-field
                        label="Stand Color*"
                        outlined
                        required
                        dense
                        hide-details
                        v-model="postBody.stand_color"
                      ></v-text-field>
                    </v-col>

                  </v-row>
              
                <v-card-actions class="justify-center">
                  <v-btn
                    color="success"
                    :disabled="!valid"
                    raised
                    dark
                    large
                    @click="Save()"
                  >
                    SAVE
                  </v-btn>
                </v-card-actions>
  </v-container>

                <!-- <v-footer class="mt-6 justify-center">
          
        </v-footer> -->
              </v-form>
            </v-card>
          </div>
        </v-sheet>
      </v-navigation-drawer>
    </div>

    <v-snackbar v-model="snackbar" shaped top :color="snackbarcolor">
      {{ snackbartext }}
      <v-btn color="indigo" text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
//import { mapMutations } from 'vuex'
import axios from "axios";
export default {
  data() {
    return {
      modal2: false,
      valid: false,
      snackbar: false,
      snackbartext: "",
      snackbarcolor: "primary",
      mode: "NEW",
      newmode: true,
      sheet: false,
      EntryMode: "",
      search: "",
      loadingstatus: false,
      isUploading: false,
      getcity_id: "",
      VenueID: "",
      SelVenue: "",
      VenueName: [],

      postBody: {
        stand_name: "",
        print_text: "",
        gate_no: "",
        stand_color: "",
        venue_id:0
      },

      headers: [
       
        { text: "stand_id", value: "stand_id" },
        { text: "stand_name", value: "stand_name" },
        { text: "print_text", value: "print_text" },
        { text: "gate_no", value: "gate_no" },
        { text: "stand_color", value: "stand_color" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      desserts: [],
    };
  },
  mounted() {
    this.$store.commit("setPageTitle", "Stand Master");
   // this.Reload(2);
    this.bindVenue();
  },
  methods: {
    showSnackbar: function (scolor, stext) {
      this.snackbar = true;
      this.snackbartext = stext;
      this.snackbarcolor = scolor;
    },

    Reload: function (vid) {
      this.loadingstatus = true;
      axios
        .get(this.$apiPath + "Stand/GetStandByVid/" + vid, {
          headers: { Appkey: this.$aKey },
        })
        .then((res) => {
          this.desserts = res.data.result;
          this.loadingstatus = false;
        })
        .catch()
        .finally();
    },

    New() {
      this.EntryMode = "New Stand";
      this.ClearItem();
      this.bindVenue();
      this.sheet = true;
    },
    searchdata(){
      this.Reload(this.SelVenue);
    },

    Save() {
      this.$refs.form.validate();

      if (this.editedIndex > -1) {
        Object.assign(this.desserts[this.editedIndex], this.editedItem);
      } else {
        this.desserts.push(this.editedItem);
        if (this.EntryMode == "New Stand") {
          this.postBody.venue_id = parseInt(this.SelVenue);
          axios
            .post(this.$apiPath + "stand", this.postBody, {
              headers: { Appkey: this.$aKey },
            })
            .then((res) => {
              if (res.data.status == "Success") {
                this.showSnackbar("Success", "Stand Created!");
                // this.ClearItem();
                this.Reload(this.SelVenue);
                this.sheet = false;
              }
            })
            .catch()
            .finally();
        } else {
         
         
          axios
            .put(this.$apiPath + "stand/" + this.VenueID, this.postBody, {
              headers: { Appkey: this.$aKey },
            })
            .then((res) => {
              if (res.data.status == "Success") {
                // console.log(this.postBodyUpdate);
                this.showSnackbar("Success", "Venue Updated!");
                //  this.ClearItem();
                this.sheet = false;
                this.Reload(this.SelVenue);
              }
            })
            .catch()
            .finally();
        }
      }
      //  this.close();
    },

    editItem(item) {
      this.EntryMode = "Edit Stand";
      this.VenueID = item.stand_id;
      this.postBody.stand_name = item.stand_name;
      this.postBody.print_text = item.print_text;
      this.postBody.gate_no = item.gate_no;
      this.postBody.stand_color = item.stand_color;

    
      this.sheet = true;
      //  this.postBody.city_id = parseInt(this.SelCity.city_id);
      //  console.log(this.postBody);
    },

    ClearItem() {
      this.EntryMode = "New Stand";
      this.VenueID = "";
      this.postBody.venue_name = "";
      this.postBody.venue_address = "";
      this.postBody.google_location = "";
      this.bindVenue();
      // this.SelCity = item.city_id;
      // this.sheet = true;
    },

    deleteItem(item) {
      //alert(item.Vendor_Id);
      const index = this.desserts.indexOf(item);
      if (confirm("Are you sure you want to delete this Venue?")) {
        axios
          .delete(this.$apiPath + "venue/" + item.venue_id, {
            headers: { Appkey: this.$aKey },
          })
          .then(() => {
            // this.desserts = res.data.result;
            this.showSnackbar("Success", "Venue Deleted !");
            this.Reload(this.SelVenue);
          })
          .catch()
          .finally();
      }
      this.desserts.splice(index, 1);
      this.Reload(this.SelVenue);
    },

    bindVenue: function () {
      this.ItemCity = [];
      this.SelCity = "";
      axios
        .get(this.$apiPath + "venue", {
          headers: { Appkey: this.$aKey },
        })
        .then((res) => {
          this.VenueName = res.data.result;
          
        })
        .catch()
        .finally();
    },
  },
};
</script>

<style>
</style>